import { HttpClient } from '../../protocols/http/httpClient'
import {
  IAssignUserRole,
  AssignRoleParams,
  UserRoleAssignment
} from '../../../domain/usecases/UserRoles'

export class RemoteAssignUserRole implements IAssignUserRole {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async assign(params: AssignRoleParams): Promise<UserRoleAssignment> {
    const httpResponse = await this.httpClient.post?.({
      url: `${this.url}/user-roles`,
      data: params
    })

    return httpResponse
  }
}
